module.exports = __webpack_public_path__ + "img/icon_ipo_suggestion_2@2x.0adddf30.png";